import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2018/Inv/";

export const invitaciones2018 = [
    {
        'numInvitacion' : 'IO-913005997-E249-2018',
        'procedimiento' : [
            {
                'numProc' : 'Procedimiento de Invitación a Cuando Menos Tres Personas núm. IO-913005997-E249-2018',
                'vigenciaProc' : 'Vigencia: 9 de noviembre de 2018 (único día)',
                'descripcionProc' : 'Construcción de sanitarios y rehabilitación de líneas de conducción hidráulicas, sanitarias y de gas en el Mercado Municipal de Almoloya, ubicada en la localidad y Municipio de Almoloya, Estado de Hidalgo.',
                'urlAnexosProc' : `${ ligabase }E249/E249.rar`,
                'resultadosProc' : [
                    {
                        'resultado' : 'Oficio Invitación',
                        'urlResultado' : `${ ligabase }E249/OIE249.pdf`,
                    },
                    {
                        'resultado' : 'Aclaraciones',
                        'urlResultado' : `${ ligabase }E249/JAE249.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlResultado' : `${ ligabase }E249/APE249.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlResultado' : `${ ligabase }E249/FAE249.pdf`,
                    } 
                ]
            }
        ]
    }
]